package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
sealed class AdminQueueItem {
    abstract val id: String
    abstract val createdAt: String
    abstract val priorActions: Int

    @Serializable
    @SerialName("listing_report")
    data class ListingReportItem(
        override val id: String,
        @SerialName("created_at") override val createdAt: String,
        @SerialName("listing_id") val listingId: String,
        @SerialName("listing_title") val listingTitle: String?,
        @SerialName("thumbnail_url") val thumbnailUrl: String?,
        @SerialName("reporter_id") val reporterId: String,
        @SerialName("reporter_name") val reporterName: String?,
        val reason: String,
        val details: String?,
        @SerialName("reporter_count") val reporterCount: Int,
        @SerialName("prior_actions") override val priorActions: Int = 0,
    ) : AdminQueueItem()

    @Serializable
    @SerialName("user_report")
    data class UserReportItem(
        override val id: String,
        @SerialName("created_at") override val createdAt: String,
        @SerialName("reported_user_id") val reportedUserId: String,
        @SerialName("reported_user_name") val reportedUserName: String?,
        @SerialName("reported_user_avatar_url") val reportedUserAvatarUrl: String?,
        @SerialName("reporter_id") val reporterId: String,
        @SerialName("reporter_name") val reporterName: String?,
        val reason: String,
        val details: String?,
        @SerialName("reporter_count") val reporterCount: Int,
        @SerialName("prior_actions") override val priorActions: Int = 0,
    ) : AdminQueueItem()

    @Serializable
    @SerialName("active_listing")
    data class ActiveListingItem(
        override val id: String,
        @SerialName("created_at") override val createdAt: String,
        val title: String,
        @SerialName("thumbnail_url") val thumbnailUrl: String?,
        @SerialName("seller_id") val sellerId: String?,
        @SerialName("seller_name") val sellerName: String?,
        @SerialName("price_cents") val priceCents: Long,
        val currency: String,
        @SerialName("report_count") val reportCount: Int,
        @SerialName("prior_actions") override val priorActions: Int = 0,
    ) : AdminQueueItem()
}
